import { useEffect, useState } from "react";
import { fetchCatalog } from "../api/catalog";

let cache = null;
let inflight = null;

// Normalizes whatever fetchCatalog returns into { products: [...] }
function normalize(result) {
  return Array.isArray(result)
    ? { products: result }
    : result || { products: [] };
}

export function useCatalog() {
  const [state, setState] = useState({
    products: cache?.products || [],
    loading: !cache,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        if (!inflight) inflight = fetchCatalog();
        const raw = await inflight;
        const normalized = normalize(raw);
        cache = normalized;
        if (!cancelled) {
          setState({
            products: normalized.products,
            loading: false,
            error: null,
          });
        }
      } catch (e) {
        if (!cancelled) setState({ products: [], loading: false, error: e });
      } finally {
        inflight = null;
      }
    }

    if (!cache) {
      load();
    } else {
      // already cached
      setState({ products: cache.products, loading: false, error: null });
    }

    return () => {
      cancelled = true;
    };
  }, []);

  const refresh = async () => {
    const raw = await fetchCatalog();
    const normalized = normalize(raw);
    cache = normalized;
    setState({ products: normalized.products, loading: false, error: null });
  };

  return { ...state, refresh };
}
